import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import Utils from '@/common/utils/utils';
import Constant from '@/common/constant/Constant';
import { matchPath } from 'react-router';
import ThinkingInfo from './ThinkingInfo';

/**
 * @param {*} data  data: text or {content: text}
 * @param {*} isWaitingChat  data rendered WaitingGPTResponse is text format and MessagesList is object like {content: text}
 * @returns
 */
export default function AIResponse({ data, isWaitingChat, isPublicSite }) {
    return (
        <>
            {!Utils.isEmptyArray(data.reasoningData) && (
                <ThinkingInfo reasoningData={data.reasoningData} />
            )}
            <ReactMarkdown
                className="ai-response"
                remarkPlugins={[remarkGfm]}
                components={{
                    a: ({ href, children }) => {
                        const UNSAFELY_PROTOCOL_REGEX = [
                            Constant.REGEX_FTP,
                            Constant.REGEX_FILE,
                            Constant.REGEX_NOTES
                        ];
                        let renderHref = href;
                        if (!Utils.isEmptyArray(children)) {
                            renderHref = UNSAFELY_PROTOCOL_REGEX.some(i => i.test(children[0]))
                                ? children[0]
                                : href;
                        }
                        return (
                            <CustomerUrl href={renderHref} isPublicSite={isPublicSite}>
                                {children}
                            </CustomerUrl>
                        );
                    }
                }}
            >
                {transformUrl({ isWaitingChat, data })}
            </ReactMarkdown>
        </>
    );
}

const transformUrl = ({ isWaitingChat, data }) => {
    const rawContent = isWaitingChat ? data : data?.content;

    if (!rawContent) {
        return '';
    }

    // Strip backticks around URLs so they render as links instead of <code>
    const CLEAR_BACKTICKET_REGEX = /`((https?|ftp|file|[Nn]otes):\/\/[^\s`]+)`/g;
    const content = cleanOpenAICitationAnnotations(rawContent).replace(CLEAR_BACKTICKET_REGEX, '[$1]($1)');

    const urlRegex = /(ftp|file|Notes|notes):\/\/[^\s)\]}"'`<>^&({[]+[^\s)\]}"'`<>^&({[,.!?*@%$#\\/]/g;

    const replacedText = content.replace(urlRegex, url => {
        return `[${url}](${url})`;
    });

    return replacedText;
};

const cleanOpenAICitationAnnotations = (text = '') => {
    if (typeof text !== 'string') return text;

    return text.replace(/\uE200[\s\S]*?(?:\uE201|$)/g, '');
};

const CustomerUrl = ({ href, children, isPublicSite }) => {
    const urlType = Utils.detectUrlType(href);
    let customHref = href;
    let isUrlInDesk = false;
    switch (urlType) {
        case Constant.PROTOCOL.HTTP:
        case Constant.PROTOCOL.HTTPS:
            let fullUrl = {};
            try {
                fullUrl = new URL(href);
                let urlPathName = fullUrl.pathname;
                let matchUrl = matchPath(urlPathName, {
                    path: Constant.SHARE_TICKET_ROUTER,
                    exact: true,
                    strict: true
                });
                const matchUrlShortLink = matchPath(urlPathName, {
                    path: Constant.SHORT_LINK_TICKET_ROUTER,
                    exact: true,
                    strict: true
                });

                // So sánh domain và router
                if (
                    ((!Utils.isEmptyObject(matchUrl) && matchUrl.isExact) ||
                        !!matchUrlShortLink?.isExact) &&
                    !isPublicSite
                ) {
                    const params = matchUrl ? matchUrl.params : null;
                    customHref = href;
                    if (params?.id) {
                        const id = params.id;
                        const newId = Utils.removeExtraCharactersOfIdTicket(id);
                        customHref = href.replace(id, newId);
                    }
                    isUrlInDesk = true;
                }
            } catch (error) {
                customHref = '#';
            }
            break;
        default:
            customHref = href;
    }

    if (isUrlInDesk) {
        return (
            <span
                className="markdown-redirect"
                onClick={() => window.onClickUrlViewTicket(customHref)}
            >
                {children}
            </span>
        );
    }

    return (
        <a
            className="markdown-redirect"
            href={customHref}
            target={customHref === '#' ? '' : '_blank'}
            rel="noopener noreferrer"
        >
            {children}
        </a>
    );
};
